import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/index'
import Upgrade from '@/views/upgrade'
import Develop from '@/views/develop'
import Portfolio from '@/views/portfolio'
import Contact from '@/views/contact'
import Resume from '@/views/resume'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },

  {
    path: '/',
    name: 'home',
    component: Home
  },

  // {
  //   path: '/upgrade/with-free-site-evaluation',
  //   name: 'upgrade',
  //   component: Upgrade
  // },

  // {
  //   path: '/develop/with-free-consultation',
  //   name: 'develop',
  //   component: Develop
  // },

  // {
  //   path: '/portfolio',
  //   name: 'portfolio',
  //   component: Portfolio
  // },

  // {
  //   path: '/contact',
  //   name: 'contact',
  //   component: Contact
  // },

  {
    path: '/resume',
    name: 'resume',
    component: Resume
  },

  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import( '@/views/sign-in' )
  },

  {
    path: '/training/:id',
    name: 'training',
    component: () => import( '@/views/training' )
  },

  {
    path: '/blog',
    component: () => import( '@/layouts/blog' ),
    children: [
      { 
        path: '',
        name: 'blog',
        component: () => import( '@/views/articles' ) 
      },
      { 
        path: '/article/:id',
        name: 'article',
        component: () => import( '@/views/article' ) 
      },

      {
        path: 'about',
        name: 'about',
        component: () => import( '@/views/about' )
      },

      {
        path: 'contact',
        name: 'contact',
        component: () => import( '@/views/contact' )
      },

      {
        path: '*',
        redirect: '/blog'
      },
    ]
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router